
/* Allows us to conform to our normal standard of importing functions. We *could*
* just access 'window.middlewareState()' anywhere in our app, but by importing this
* function from this file, we continue to follow our schema.
*/
const middlewareState = {
  myfs: {
    getState: () => window.middlewareStateMyFS && window.middlewareStateMyFS(),
  },
  myee: {
    getState: () => window.middlewareStateMyEE && window.middlewareStateMyEE(),
  },
};

export default middlewareState;
